import { Component, Input, OnInit } from '@angular/core';
import { LoyaltyCategoryType, ProviderName, SocialService } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';

@Component({
  selector: 'fgbcl-social-share-modal',
  templateUrl: './social-share-modal.component.html',
  styleUrls: ['./social-share-modal.component.scss'],
})
export class SocialShareModalComponent implements OnInit {
  @Input() shareType: string;
  @Input() itemId: number;
  @Input() urlPage: string;
  @Input() loyaltyCategoryType: LoyaltyCategoryType;
  providerName = ProviderName;
  screenType = ScreenType;

  constructor(private socialService: SocialService) {}

  ngOnInit(): void {}

  shareItem(
    providerLink: string = '',
    providerName: ProviderName = ProviderName.Facebook,
    screenSize: ScreenType = this.screenType.Mobile
  ) {
    return this.socialService.shareLoyalty(
      this.itemId,
      this.urlPage,
      this.loyaltyCategoryType,
      providerName,
      providerLink,
      screenSize
    );
  }

  shareLink(providerName: ProviderName) {
    let providerLink = '';
    if (providerName == ProviderName.Dummy) {
      providerLink = '';
    } else if (providerName == ProviderName.Facebook) {
      providerLink = 'https://www.facebook.com/sharer/sharer.php?u=';
    } else if (providerName === ProviderName.Twitter) {
      providerLink = 'https://x.com/intent/tweet?url=';
    }
    return this.shareItem(providerLink, providerName, this.screenType.Desktop);
  }
}
